import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';

import { trackByValue } from '@core/common-legacy';
import { MessageComponent } from '@core/user-interface-legacy';

import type { LegalDialogConfig } from '../../types';

@Component({
  selector: 'rt-integration-list-legal-dialog-content',
  imports: [MessageComponent, NgTemplateOutlet],
  templateUrl: './integration-list-legal-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./integration-list-legal-dialog-content.component.less'],
})
export class IntegrationListLegalDialogContentComponent {
  public readonly claimsList = input<SafeHtml[]>(undefined!);
  public readonly listType = input<LegalDialogConfig['listType']>('unordered');
  @Input() public claimsHeading: SafeHtml | undefined;
  @Input() public textUnderClaims: SafeHtml | undefined;

  public trackByValue = trackByValue;

  public get orderedClaims(): boolean {
    return this.listType() === 'ordered';
  }
}
